import React from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="py-20 px-6 bg-brown-900 text-cream-50" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <FadeIn data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gold-400 text-center" data-id="element-141">
            La Brecha Espiritual en tu Hogar
          </h2>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-cream-100/90" data-id="element-142">
            <p data-id="element-143">
              Has intentado restaurar la armonía con tus propias fuerzas,
              pidiendo perdón o guardando silencio para no pelear, pero el aire
              sigue sintiéndose "cargado". No es solo un problema de carácter;
              es una brecha espiritual en el vallado de tu hogar.
            </p>
            <p data-id="element-144">
              Cuando no hay un altar de oración encendido, la discordia
              encuentra puertas legales para entrar. Tus hijos lo sienten, tu
              matrimonio lo sufre y tu descanso se desvanece.
            </p>
            <p className="font-medium text-cream-50 text-xl pt-4 border-t border-brown-800" data-id="element-145">
              Es momento de dejar de pelear contra las personas y empezar a
              gobernar tu casa bajo el diseño de Dios.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}